import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../components/common';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={<SearchX className="size-7" />}
      title={t('notFound.title')}
      action={
        <Link to="/" className="btn-primary">
          {t('notFound.home')}
        </Link>
      }
    >
      {t('notFound.body')}
    </EmptyState>
  );
}
